import { useEffect, useState } from 'react'
import { inject, observer } from 'mobx-react';
import FormMaster from '../FormMaster'
import { CommonService } from "../../../services";
import { isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next'

let firstRender = false
const Vehicle = inject("authenStore")(observer((props) => {
  const { t } = useTranslation(['vehicle', 'common'])
  let authenStore = props.authenStore
  let { getAccountAuth } = authenStore // STATE
  let auth = { action_user_id: getAccountAuth?.user_id, token_id: getAccountAuth?.access_token }

  const [masterOptions, setMasterOptions] = useState({
    vehicle_province: [],
    service: [],
    vehicle_type: [],
    vehicle_register_type: [],
    vehicle_status: [],
    vehicle_brand: [],
    vehicle_model: [],
    vehicle_color: [],
    subcontract: [],
    fuel: []
  })

  useEffect(() => {
    if (firstRender || !isEmpty(getAccountAuth)) {
      CommonService.getMasterData(auth, "vehicle_province,service,vehicle_type,vehicle_register_type,vehicle_status,vehicle_brand,vehicle_model,vehicle_color,subcontract,fuel")
        .then((res: any) => {
          let vehicle_province = res.result.vehicle_province.map((item) => ({ label: item.province_name, value: item.province_id }))
          let service = res.result.service.map((item) => ({ label: item.service_name, value: item.service_id }))
          let vehicle_type = res.result.vehicle_type.map((item) => ({ label: item.vehicle_type_name, value: item.vehicle_type_id }))
          let vehicle_register_type = res.result.vehicle_register_type.map((item) => ({ label: item.register_type_name, value: item.register_type_id }))
          let vehicle_status = res.result.vehicle_status.map((item) => ({ label: item.status_name, value: item.status_code }))
          let vehicle_brand = res.result.vehicle_brand.map((item) => ({ label: item.brand_name, value: item.brand_id }))
          let vehicle_model = res.result.vehicle_model.map((item) => ({ label: item.model_name, value: item.model_id }))
          let vehicle_color = res.result.vehicle_color.map((item) => ({ label: item.color_name, value: item.color_id }))
          let subcontract = res.result.subcontract.map((item) => ({ label: item.sub_name, value: item.sub_id }))
          let fuel = res.result.fuel.map((item) => ({ label: item.fuel_name, value: item.fuel_id }))
          // setOptionStatus(common_status)
          setMasterOptions({
            ...masterOptions,
            vehicle_province,
            service,
            vehicle_type,
            vehicle_register_type,
            vehicle_status,
            vehicle_brand,
            vehicle_model,
            vehicle_color,
            subcontract,
            fuel
          })
        })
        .catch((err) => {
          console.log(`Load master data : ${err}`)
        })
    }
    else
      firstRender = true
  }, [getAccountAuth])

  return <FormMaster
    title={t('car_information')}
    tableConfig={{
      key: "id",
      apiPath: "vehicle/list",
      allowDelete: {
        visible: true,
        key: "vehicle_id",
        apiPath: "vehicle/delete",
        paramType: 'param'
      },
      optionDeleteFag: true,
      defaultColumn: [],
      columns: [
        {
          dataField: 'no',
          caption: t('no'),
          width: 60,
          alignment: "center",
          allowFiltering: false
        },
        {
          dataField: 'licenseplate',
          caption: t('license_plate'),
          allowFiltering: true
        },
        {
          dataField: 'vehicle_name',
          caption: t('car_number'),
          allowFiltering: true
        },
        {
          dataField: 'license_province_name',
          caption: t('province'),
          allowFiltering: true
        },
        {
          dataField: 'chassis_no',
          caption: t('chassis_number'),
          allowFiltering: true
        },
        {
          dataField: 'vehicle_type_name',
          caption: t('vehicle_type'),
          allowFiltering: true
        },
        {
          dataField: 'driver_names',
          caption: t('driver'),
          allowFiltering: true
        },
        {
          dataField: 'status_name',
          caption: t('status'),
          allowFiltering: true
        },
        {
          dataField: 'updated_by',
          caption: t('edit_by')
        }
      ],
      exportExcel: {
        fileName: t('car_information'),
        columnConfig: [
          { label: t('no'), value: 'no' },
          { label: t('license_plate'), value: 'licenseplate' },
          { label: t('car_number'), value: 'vehicle_name' },
          { label: t('province'), value: 'license_province_name' },
          { label: t('chassis_number'), value: 'chassis_no' },
          { label: t('vehicle_type'), value: 'vehicle_type_name' },
          { label: t('driver'), value: 'driver_names' },
          { label: t('status'), value: 'status_name' },
          { label: t('edit_by'), value: 'updated_by' }
        ]
      }
    }}
    formData={{
      sub_id: "",
      vehicle_name: "",
      licenseplate: "",
      licenseplate_tail: "",
      license_province_id: "",
      license_tail_province_id: "",
      vehicle_type_id: "",
      register_type_id: "",
      status: "Y",
      chassis_no: "",
      color_id: "",
      brand_id: "",
      model_id: "",
      fuel_id: "",
      driver_ids: ""
    }}
    modalConfig={{
      screenName: "vehicle",
      visible: true,
      title: "รถ",
      required: ["licenseplate", "vehicle_type_id", "sub_id"],
      fieldTypeNumber: [],
      paramName: "vehicle_id",
      // width: "w-1/2",
      apiPath: {
        "get": '',
        "post": 'vehicle/add',
        "put": 'vehicle/update'
      },
      elements: [
        {
          fieldName: "licenseplate",
          label: t('license_plate'),
          placeholder: t('license_plate'),
          required: true,
          inputType: "text"
        },
        {
          fieldName: "license_province_id",
          label: t('province_of_registration'),
          placeholder: t('province_of_registration'),
          inputType: "select",
          allowClear: true,
          options: masterOptions.vehicle_province
        },
        {
          fieldName: "licenseplate_tail",
          label: "ทะเบียนหาง",
          placeholder: "ทะเบียนหาง",
          required: false,
          inputType: "text"
        },
        {
          fieldName: "license_tail_province_id",
          label: t('province_of_registration'),
          placeholder: t('province_of_registration'),
          inputType: "select",
          allowClear: true,
          options: masterOptions.vehicle_province
        },
        {
          fieldName: "vehicle_name",
          label: t('car_number'),
          placeholder: t('car_number'),
          required: false,
          inputType: "text"
        },
        {
          fieldName: "chassis_no",
          label: t('chassis_number'),
          placeholder: t('chassis_number'),
          required: false,
          inputType: "text"
        },
        {
          fieldName: "brand_id",
          label: t('car_brand'),
          placeholder: t('car_brand'),
          inputType: "select",
          allowClear: true,
          options: masterOptions.vehicle_brand
        },
        {
          fieldName: "model_id",
          label: t('model'),
          placeholder: t('model'),
          inputType: "select",
          allowClear: true,
          options: masterOptions.vehicle_model
        },
        {
          fieldName: "color_id",
          label: t('car_color'),
          placeholder: t('car_color'),
          inputType: "select",
          allowClear: true,
          options: masterOptions.vehicle_color
        },
        {
          fieldName: "fuel_id",
          label: t('fuel_type'),
          placeholder: t('fuel_type'),
          inputType: "select",
          allowClear: true,
          options: masterOptions.fuel
        },
        {
          fieldName: "vehicle_type_id",
          label: t('vehicle_type'),
          placeholder: t('vehicle_type'),
          required: true,
          inputType: "select",
          options: masterOptions.vehicle_type
        },
        {
          fieldName: "register_type_id",
          label: t('vehicle_type_department'),
          placeholder: t('vehicle_type_department'),
          inputType: "select",
          allowClear: true,
          options: masterOptions.vehicle_register_type
        },
        {
          fieldName: "weight",
          showUpdateOnly: true,
          label: t('loaded_weight'),
          placeholder: t('loaded_weight'),
          disabled: true,
          inputType: "text"
        },
        {
          fieldName: "dimension",
          showUpdateOnly: true,
          label: t('volume_area'),
          placeholder: t('volume_area'),
          disabled: true,
          inputType: "text"
        },
        {
          fieldName: "driver_ids",
          label: t('driver'),
          placeholder: t('driver'),
          inputType: "select",
          multiple: true,
          allowClear: true,
          options: masterOptions.service
        },
        {
          fieldName: "sub_id",
          label: t('subcontractor'),
          placeholder: t('subcontractor'),
          required: true,
          inputType: "select",
          options: masterOptions.subcontract
        },
        {
          showSearch: false,
          fieldName: "status",
          label: t('status'),
          placeholder: t('status'),
          inputType: "select",
          defaultValue: "Y",
          options: masterOptions.vehicle_status
        },
        {}
      ]
    }}
  />
}))

export default Vehicle